import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoRadio: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, onEnterKeyDown, comOpcaoNenhum, valorOpcaoNenhum = 'nenhum' }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onEnterKeyDown?.();
            e.preventDefault();
        }
    };

    return (
        <Grid item xs={12} sm={12} md={6} key={indice.idIndice}>
            <FormControl key={'FormControl-' + indice.idIndice}>
                <FormLabel key={'FormLabel' + indice.idIndice}>{indice.nomeIndice}</FormLabel>
                <RadioGroup
                    key={'RadioGroup-' + indice.idIndice}
                    row
                    value={valor ?? ''}
                    onKeyDown={handleKeyDown}
                    onChange={(event) => onChange(event.target.value)}
                >
                    {comOpcaoNenhum && (
                        <FormControlLabel
                            key={'nenhum-' + indice.idIndice}
                            value={valorOpcaoNenhum}
                            control={<Radio disabled={disabled} />}
                            label="Nenhum"
                            sx={{ fontStyle: 'italic' }}
                        />
                    )}
                    {!!indice.opcoes &&
                        indice.opcoes.split('^ ').map((op) => (
                            <FormControlLabel key={op + '-' + indice.idIndice} value={op} control={<Radio disabled={disabled} />} label={op} />
                        ))}
                </RadioGroup>
            </FormControl>
        </Grid>
    );
};
